module.exports = __webpack_public_path__ + "img/sr.be27d1ae.svg";